// extracted by mini-css-extract-plugin
export default {"container":"care_container__WJhbl","head":"care_head__MOz0V","head_text":"care_head_text__Phjeb","body":"care_body__k+mJB","link":"care_link__bDaNw"};